import React, { useEffect } from 'react';
import Form from './request-a-quote-form';
import { ModalProps, RequestAQuoteFormProps } from './types';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { ExtendedWindowType } from '../../../helpers/global-types';

const RequestAQuoteForm = (props: RequestAQuoteFormProps) => {
  const contractorData = props.contractor as ModalProps;

  useEffect(() => {
    const global = window as ExtendedWindowType;
    global.dataLayer?.push({
      event: 'request_quote_form_view',
      event_category: 'find a contractor',
      event_action: 'request a quote form view',
      event_attributes: {
        contractor_id: contractorData?.id,
        contractor_name: contractorData?.contractorName,
        contractor_certificates_count: contractorData?.numberOfCertificates,
        contractor_rating: contractorData?.rating,
        contractor_reviews_count: contractorData?.numberOfReviews,
        contractor_certificate_name: contractorData?.certificateName,
        contractor_type: contractorData?.type,
        form_name: 'request a quote form'
      }
    });
  }, []);
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={props.reCaptchaSiteKey}
      useEnterprise={true}
    >
      <Form {...props} contractor={contractorData} />
    </GoogleReCaptchaProvider>
  );
};

export default RequestAQuoteForm;
